import React from 'react';
import PropTypes from 'prop-types';
import getUnicodeFlagIcon from 'country-flag-icons/unicode';

const CountryFlag = ({
  unicodeFlags,
  value,
  selectedOption,
  iconComponent: Icon,
  className = '',
  internationalIcon,
}) => {
  if (unicodeFlags && value) {
    return (
      <div className="PhoneInputCountryIconUnicode">
        {getUnicodeFlagIcon(value)}
      </div>
    );
  }

  if (!(unicodeFlags && value)) {
    return (
      <Icon
        className={className}
        country={value}
        label={selectedOption && selectedOption.label}
        aspectRatio={unicodeFlags ? 1 : undefined}
        internationalIcon={internationalIcon}
      />
    );
  }

  return null;
};

CountryFlag.propTypes = {
  className: PropTypes.string,
  iconComponent: PropTypes.func,
  internationalIcon: PropTypes.func,
  selectedOption: PropTypes.object,
  unicodeFlags: PropTypes.bool,
  value: PropTypes.string,
};

export default CountryFlag;
